export const techLaunchData = {
  title: "AI改变未来",
  subtitle: "下一代智能生产力平台",

  features: [
    "智能自动化",
    "数据分析",
    "无限创造"
  ],

  stats: {
    users: "100万+",
    growth: "320%"
  },

  ending: "未来已来"
};
